import React from 'react';
import { Link } from 'react-router-dom';
import WarningIcon from '@mui/icons-material/WarningAmber';
import { Text } from '../../../../common/text/Text';
import { Lozenge } from '../../../../common/lozenge/Lozenge';
import { CapGauge } from '../components/capgauge';

export const createHeadTable = () => ({
  cells: [
    {
      key: 'jurisdiction',
      content: 'Juridiction',
      shouldTruncate: true,
      isSortable: true,
      width: 14,
    },
    {
      key: 'airline',
      content: 'Compagnie',
      shouldTruncate: true,
      isSortable: true,
      width: 16,
    },
    {
      key: 'flightdates',
      content: 'Dates de vols',
      shouldTruncate: true,
      isSortable: false,
      width: 20,
    },
    {
      key: 'claims',
      content: 'Dossiers',
      shouldTruncate: true,
      isSortable: false,
      width: 12,
    },
    {
      key: 'total',
      content: 'Total demandé',
      shouldTruncate: false,
      isSortable: false,
      width: 26,
    },
    {
      key: 'status',
      content: 'Statut',
      shouldTruncate: true,
      isSortable: true,
      width: 12,
    },
  ],
});

const renderFlightDates = (saisine) => saisine.flightRange() || '—';

export const createRowsTable = (saisines) => saisines.map((saisine) => ({
  key: saisine._id,
  cells: [
    {
      key: `jurisdiction-${saisine._id}`,
      content: (
        <Link to={{ pathname: '/saisine', search: `?id=${saisine._id}&from=saisines` }}>
          <p>{saisine.jurisdiction}</p>
        </Link>
      ),
    },
    {
      key: `airline-${saisine._id}`,
      content: (<Text color="secondary" variant="body2">{saisine.airline_name}</Text>),
    },
    {
      key: `dates-${saisine._id}`,
      content: (<Text color="secondary" variant="body2">{renderFlightDates(saisine)}</Text>),
    },
    {
      key: `claims-${saisine._id}`,
      content: (
        <div>
          <Text color="secondary" variant="body2">
            {`${saisine.nbClaims()} · ${saisine.nbPassengers()} pax`}
          </Text>
          {saisine.status !== 'SENT' && saisine.nbClaims() > 0 && !saisine.generationReady()
            && <Lozenge text="pax incomplets" red />}
        </div>
      ),
    },
    {
      key: `total-${saisine._id}`,
      content: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {saisine.warnings.length > 0
            && <WarningIcon fontSize="small" style={{ color: '#ff8b00' }} />}
          <CapGauge total={saisine.computedTotal} warning={saisine.warnings.length > 0} />
        </div>
      ),
    },
    {
      key: `status-${saisine._id}`,
      content: saisine.status === 'SENT'
        ? <Lozenge text="Envoyée" blue />
        : <Lozenge text="Ouverte" green />,
    },
  ],
}));
